export { fetchTypeahead } from 'next-flight-server-reference-proxy-loader?id=7fe479d0718faafc67e0e8742afebbd34e76811181&name=fetchTypeahead!'